
<ng-container *ngIf="!loaded">
  <div class="subscriptionInfoView verticalCenterView">
    <div class="subscriptionInfoView__loader">
      <mat-spinner></mat-spinner>
    </div>
  </div>
</ng-container>
<ng-container *ngIf="loaded">

  <div class="subscriptionInfoView" *ngIf="activeSubscription">

    <div class="">
      <div class="">

        <div class="subscriptionInfoView__renewSub">
          <ng-container *ngIf="!userHasActiveSubscription">
            <div>You currently do not have an active subscription!</div>
            <button class="btRenewSub" mat-raised-button  color="primary" (click)="showForm()">
              <span>
                Renew your subscription 
              </span>
            </button>
          </ng-container>
        </div>

        <div class="subscriptionInfoView__subscriptions">
            <div class="subscriptionsItem subscriptionInfoView__subscriptionsItem"  *ngFor="let data of subscribtions">
              <div class="subscriptionsItem__row">
                <div class="subscriptionsItem__label">Name</div>
                <div class="subscriptionsItem__value">{{data.firstName}} {{data.lastName}}</div>
              </div>
              <div class="subscriptionsItem__row">
                <div class="subscriptionsItem__label">ZIP</div>
                <div class="subscriptionsItem__value">{{data.zip}}</div>
              </div>
              <div class="subscriptionsItem__row">
                <div class="subscriptionsItem__label">CC</div>
                <div class="subscriptionsItem__value">{{data.creditCard}}</div>
              </div>
              <div class="subscriptionsItem__row">
                <div class="subscriptionsItem__label">Type</div>
                <div class="subscriptionsItem__value">{{data.type}}</div>
              </div>
              <div class="subscriptionsItem__row">
                <div class="subscriptionsItem__label">Price</div>
                <div class="subscriptionsItem__value">{{data.price}}</div>
              </div>
              <div class="subscriptionsItem__row">
                <div  class="subscriptionsItem__label">Next Billing Date</div>
                <div class="subscriptionsItem__value"><ng-container *ngIf="isActive(data.status)">{{data.nextBillingDate.format("MM/DD/YYYY")}}</ng-container></div>
              </div>
                <div class="subscriptionsItem__actions">
                <button *ngIf="isActive(data.status); else canceledBlock" mat-stroked-button color="warn" (click)="cancelSubscriptionDialog(data)">Cancel subscription</button>
                <ng-template #canceledBlock>
                   Canceled<div class="first"  style="font-size:12px" *ngIf="data.nextBillingDate!=null && data.subscribtionId==getFirstInactive">Valid until {{data.nextBillingDate.format("MM/DD/YYYY")}}</div>
                </ng-template>
              </div>
            </div>
        </div>

      </div>
    </div>
  </div>
  <div *ngIf="!activeSubscription" style="width: 100%; min-height: 50vh" class="subscription">
    <app-mobile-subscribtion (subscribeActionFinished)="subscribeFinished()" [isSubscriptionInfo]="isSubscriptionInfo"></app-mobile-subscribtion>
  </div>
</ng-container>
